import {
  addCursor,
  forbiddenCursor,
  measureCursor,
  removeCursor,
  subpointCursor,
} from '../../../cross-team-shared/cursors/custom-cursors';
import {
  ToolName,
  vectorTaggingShapeTools,
} from '../../../cross-team-shared/tools-names';
import { VectorLayerEditMode } from '../../../cross-team-shared/types/tool-modes';

interface CursorSelectionParams {
  selectedTool: ToolName;
  editMode: VectorLayerEditMode;
  allowsAddingAndRemovingSubpoints: boolean;
  shapeCreationEnabled: boolean;
}

export function getCursor({
  selectedTool,
  shapeCreationEnabled,
  allowsAddingAndRemovingSubpoints,
  editMode,
}: CursorSelectionParams) {
  const shapeCreationDisabled = isShapeCreationDisabled(
    selectedTool,
    shapeCreationEnabled,
  );

  if (shapeCreationDisabled) {
    return forbiddenCursor;
  }

  return getCursorByTool(
    selectedTool,
    allowsAddingAndRemovingSubpoints,
    editMode,
  );
}

// eslint-disable-next-line complexity -- this function is complex by nature
function getCursorByTool(
  selectedTool: ToolName,
  allowsAddingAndRemovingSubpoints: boolean,
  editMode: VectorLayerEditMode,
) {
  switch (selectedTool) {
    case 'Select':
      return 'default';

    case 'Edit':
      return getSelectCursorByMode(editMode, allowsAddingAndRemovingSubpoints);

    case 'Point':
      return subpointCursor;

    case 'Line':
    case 'Arrow':
    case 'Rectangle':
    case 'SliderRectangle':
      return 'crosshair';

    case 'Polygon':
    case 'Keypoint':
      return addCursor;

    case 'Cuboid':
      return 'default';

    case 'Measure':
      return measureCursor;

    default:
      return 'auto';
  }
}

function isShapeCreationDisabled(
  selectedTool: string | undefined,
  shapeCreationEnabled: boolean,
): boolean {
  const tools = vectorTaggingShapeTools as readonly string[];
  return !shapeCreationEnabled && tools.includes(selectedTool || '');
}

function getSelectCursorByMode(
  editMode: VectorLayerEditMode,
  allowsAddingAndRemovingSubpoints: boolean,
) {
  if (!allowsAddingAndRemovingSubpoints) {
    return 'auto';
  }

  switch (editMode) {
    case 'add':
      return addCursor;
    case 'remove':
      return removeCursor;
    default:
      return 'auto';
  }
}
